import { Object3D } from 'three'
import { Raycast }  from './Raycaster'

export default class SceneVisualBase extends Object3D {
  constructor(cameraManager) {
    super()

    this.raycaster = new Raycast(cameraManager)
  }

  setPointHighlight(pointMesh, highlighted) {
    console.warn('abstract method!')
  }

  raycastPoint(mouse) {
    console.warn('abstract method!')
  }

}
